import notification from 'modules/app-core/notification-manager'
import { connectRequest } from 'modules/redux-gateway'

import { actions, selectors, constants } from '../'

import { TagsEditor } from '../components'

const FILTERED = 'filtered'

export default connectRequest({
  name: 'AvailableTags',
  route: constants.TAGS_GET,
  clearOnMount: true,
  requestOnMountParams: (props) =>
    props.dispatch(() => ({
      ItemType: props.itemType,
      ItemPublicKeys: JSON.stringify([]),
      forceGet: true,
    })),
  onSuccess: (request, dispatch) => {
    const availableTags =
      request.response &&
      request.response.AvailableTags &&
      request.response.AvailableTags.map((name) => ({ name }))
    dispatch(
      actions.loadTags([...availableTags, { name: 'Untagged' }], FILTERED)
    )
  },
  onFailure: (request, dispatch) => {
    dispatch(
      notification.actions.createErrorNotification(
        'Sorry, there was an error getting Available Tags.'
      )
    )
  },
  mapStateToProps: (state, props) => {
    const tags = selectors.getTags(state, FILTERED)

    const updateFilter =
      ({ name, IsActive = false }) =>
      () => {
        const newTags = tags.map((tag) =>
          tag.name === name ? { ...tag, IsActive: !IsActive } : tag
        )
        props.dispatch(actions.loadTags(newTags, FILTERED))
      }

    const selectAll = (bool) => () => {
      const inverseTags = tags.map((tag) => ({ ...tag, IsActive: bool }))
      props.dispatch(actions.loadTags(inverseTags, FILTERED))
    }

    return {
      Id: FILTERED,
      selectAll,
      tags,
      updateFilter,
      ...props,
    }
  },
})(TagsEditor)
